<div class="services-box" [style.background-color]="item.customField16" [style.color]="item.customField17">
    <ul>
        <li *ngFor="let img of item.images;let i=index" class="bordercss" (click)="openInNewWindow(img.customField16)">
            <a href="{{img.customField16}}">{{img.customField15}}</a></li>
    </ul>
</div>